var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTechniusLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 51,
    viewBox: "0 0 135 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_541_904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.3868 12.9609H60.3392L63.1276 16.9218L65.9009 12.9609H68.8229V23.8267H65.7523V20.2842C65.7523 19.4291 65.7674 18.4671 65.7826 17.7189H65.7523C65.3062 18.4091 64.8116 19.1298 64.3353 19.8047L63.0518 21.637L61.7531 19.8047C61.2616 19.1145 60.7852 18.4091 60.3361 17.7189H60.3058C60.3209 18.4702 60.3361 19.4291 60.3361 20.2842V23.8267H57.3838V12.9609H57.3868Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5251 12.9609H73.5958V23.8267H70.5251V12.9609Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8481 21.4262C79.5338 21.4262 79.9525 21.1849 79.9525 20.6597C79.9525 20.2535 79.6855 20.0581 79.0423 19.8504C78.402 19.6397 77.0427 19.3709 76.2083 18.8151C75.3738 18.2593 74.9399 17.4806 74.9399 16.3384C74.9399 14.1182 76.536 12.7959 78.9816 12.7959C80.086 12.7959 81.4879 13.0799 82.5013 13.5899V16.3812C81.2026 15.6604 79.816 15.3612 79.0878 15.3612C78.4324 15.3612 78.0592 15.6024 78.0592 16.0666C78.0592 16.4728 78.3413 16.6682 78.9694 16.8606C79.5945 17.0561 80.9387 17.3401 81.7882 17.8806C82.6378 18.4212 83.0717 19.2915 83.0717 20.4031C83.0717 22.6844 81.4029 23.9915 78.8814 23.9915C77.7345 23.9915 76.2568 23.7227 75.1523 23.1669V20.2413C76.5238 21.0964 78.1047 21.4262 78.8511 21.4262H78.8481Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8083 21.4262C88.494 21.4262 88.9127 21.1849 88.9127 20.6597C88.9127 20.2535 88.6457 20.0581 88.0025 19.8504C87.3622 19.6397 86.0029 19.3709 85.1685 18.8151C84.334 18.2593 83.9001 17.4806 83.9001 16.3384C83.9001 14.1182 85.4962 12.7959 87.9418 12.7959C89.0462 12.7959 90.4481 13.0799 91.4615 13.5899V16.3812C90.1628 15.6604 88.7762 15.3612 88.048 15.3612C87.3926 15.3612 87.0194 15.6024 87.0194 16.0666C87.0194 16.4728 87.3015 16.6682 87.9296 16.8606C88.5547 17.0561 89.8989 17.3401 90.7484 17.8806C91.598 18.4212 92.0319 19.2915 92.0319 20.4031C92.0319 22.6844 90.3631 23.9915 87.8416 23.9915C86.6947 23.9915 85.217 23.7227 84.1125 23.1669V20.2413C85.484 21.0964 87.0649 21.4262 87.8113 21.4262H87.8083Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2213 12.9609H96.292V23.8267H93.2213V12.9609Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6211 18.3937C97.6211 15.2268 100.097 12.7959 103.392 12.7959C106.687 12.7959 109.163 15.2268 109.163 18.3937C109.163 21.5606 106.703 23.9915 103.392 23.9915C100.082 23.9915 97.6211 21.5606 97.6211 18.3937ZM106.09 18.3937C106.09 16.7721 105 15.5261 103.389 15.5261C101.778 15.5261 100.689 16.7721 100.689 18.3937C100.689 20.0153 101.778 21.2613 103.389 21.2613C105 21.2613 106.09 20.0153 106.09 18.3937Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.492 12.9609H113.369L116.233 16.8944C116.831 17.7036 117.353 18.4396 117.887 19.2214H117.917C117.902 18.29 117.887 17.3616 117.887 16.4454V12.964H120.839V23.8297H117.963L115.098 19.8963C114.501 19.087 113.979 18.3511 113.445 17.5693H113.414C113.429 18.5007 113.445 19.4291 113.445 20.3453V23.8267H110.492V12.9609Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7046 27.6685H75.7441V30.2795H71.748V31.8095H75.1342V34.271H71.748V35.9231H75.9231V38.5342H68.7046V27.6685Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6834 38.702C79.106 38.702 76.6877 36.3017 76.6877 33.1317C76.6877 29.9618 79.2244 27.5034 82.7289 27.5034C83.8334 27.5034 84.8924 27.7447 85.7268 28.1783V31.1345C84.9227 30.6398 83.8638 30.2489 82.82 30.2489C80.9994 30.2489 79.7614 31.4338 79.7614 33.0859C79.7614 34.7381 80.9236 35.9535 82.8928 35.9535C83.9366 35.9535 84.9955 35.5779 85.8755 35.0221V37.9661C84.9652 38.4608 83.7727 38.702 82.6834 38.702Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1802 27.6685H90.2539V31.5866H94.1013V27.6685H97.172V38.5342H94.1013V34.1946H90.2539V38.5342H87.1802V27.6685Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8772 27.6685H101.754L104.618 31.6019C105.216 32.4142 105.738 33.1471 106.275 33.9289H106.305C106.29 32.9975 106.275 32.0691 106.275 31.1529V27.6715H109.227V38.5373H106.351L103.486 34.6038C102.888 33.7915 102.367 33.0586 101.833 32.2768H101.802C101.817 33.2082 101.833 34.1397 101.833 35.0528V38.5342H98.8802V27.6685H98.8772Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.935 27.6685H114.009V38.5342H110.935V27.6685Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.691 27.6685V33.5686C118.691 34.3504 118.855 34.9184 119.198 35.3093C119.541 35.6849 120.032 35.9262 120.675 35.9262C121.319 35.9262 121.807 35.6849 122.153 35.3093C122.496 34.9337 122.66 34.3626 122.66 33.5686V27.6685H125.612V33.8373C125.612 35.1291 125.269 36.3598 124.42 37.2607C123.57 38.1616 122.183 38.7022 120.618 38.7022C119.052 38.7022 117.665 38.1616 116.816 37.2607C115.966 36.3598 115.623 35.0986 115.623 33.8373V27.6685H118.697H118.691Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.779 36.1337C131.465 36.1337 131.884 35.8925 131.884 35.3672C131.884 34.961 131.617 34.7656 130.974 34.5579C130.333 34.3472 128.974 34.0784 128.14 33.5226C127.305 32.9668 126.871 32.1881 126.871 31.0459C126.871 28.8258 128.467 27.5034 130.913 27.5034C132.017 27.5034 133.419 27.7874 134.433 28.2974V31.0887C133.134 30.368 131.747 30.0687 131.016 30.0687C130.361 30.0687 129.987 30.3099 129.987 30.7741C129.987 31.1803 130.27 31.3758 130.898 31.5712C131.526 31.7667 132.867 32.0507 133.716 32.5912C134.566 33.1317 135 34.0021 135 35.1137C135 37.395 133.328 38.702 130.81 38.702C129.66 38.702 128.185 38.4333 127.081 37.8775V34.9519C128.452 35.807 130.033 36.1368 130.779 36.1368V36.1337Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2585 30.2826L62.5633 28.9664L61.2737 27.6685H57.8298V30.2795H61.2585V30.2826Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3292 30.2826H64.3322V30.2795L65.637 28.9664L64.3474 27.6685H62.0262L63.3188 28.9664L62.011 30.2826H61.2585V38.5373H64.3322V30.2826H64.3292Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1029 27.6685L66.3925 28.9664L65.0878 30.2795H67.7609V27.6685H65.1029Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.97
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3421 51C11.3693 51.0031 0 39.5662 0 25.5061C0 11.4429 11.3602 0 25.3299 0C39.2996 0 50.669 11.4338 50.672 25.4939C50.672 39.554 39.3118 50.9969 25.3421 51ZM25.333 2.0003C12.4586 2.0003 1.98744 12.5454 1.98744 25.5061C1.98744 38.4638 12.4647 49.0028 25.3421 49.0028C38.2164 49.0028 48.6876 38.4577 48.6876 25.4969C48.6876 12.5393 38.2104 2.0003 25.333 2.0003Z",
    fill: "url(#paint0_linear_541_904)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.3218 25.277L16.4943 13.376L11.4483 13.379L23.2758 25.277L11.3512 37.2849L11.4453 37.3796L16.3031 37.3765L28.3218 25.277Z",
    fill: "url(#paint1_linear_541_904)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3122 25.0543L25.3876 37.0622L25.4816 37.1569L30.3395 37.1539L42.3582 25.0543L30.5276 13.1533L25.4847 13.1564L37.3122 25.0543Z",
    fill: "url(#paint2_linear_541_904)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_541_904",
    x1: 46.063,
    y1: 9.55868,
    x2: 5.62553,
    y2: 40.2612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C50C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3161AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_541_904",
    x1: 20.1293,
    y1: 17.4499,
    x2: 17.9014,
    y2: 34.3831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C50C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3161AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_541_904",
    x1: 32.9641,
    y1: 24.1473,
    x2: 35.2197,
    y2: 41.0743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C50C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3161AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_541_904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 51,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechniusLogo);
export default __webpack_public_path__ + "static/media/TechniusLogo.8a6ce2456ed6f502c37923d9bd3a0a13.svg";
export { ForwardRef as ReactComponent };